import script from "./vmsAffiliationGrid.vue?vue&type=script&lang=js"
export * from "./vmsAffiliationGrid.vue?vue&type=script&lang=js"

import "./vmsAffiliationGrid.vue?vue&type=style&index=0&id=172041f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172041f2"]])

export default __exports__